import View from 'views/base/view';
import IconLoadService from 'services/loader-handler-services/icon-load-service';

const BaseAtomView = View.extend({
  autoRender: true,
  listen: {
    'dialog:show mediator': 'loadIcons',
  },
  initialize: function () {
    this.loadIcons();
  },
  getTemplateData: function () {
    return this.model;
  },
  getTemplateFunction() {
    return this.template;
  },
  loadIcons: function () {
    if (this.model.has('icons') && Array.isArray(this.model.get('icons'))) {
      this.model.get('icons').forEach((icon, index) => {
        IconLoadService.applyIcon(icon.icon, `${this.model.cid}-${index}`);
      });
    }
    if (this.model.has('iconBefore')) {
      IconLoadService.applyIcon(this.model.get('iconBefore'), this.model.get('cid'));
    }
    if (this.model.has('iconAfter')) {
      IconLoadService.applyIcon(this.model.get('iconAfter'), this.model.get('cid'));
    }
  },
});

export default BaseAtomView;
